<details>
<summary>
Project Scope: Intended and Completed Work
</summary>

<div>
PomBase currently provides <a routerLink="/gocam/model-list">{{modelCount}} pathway models</a> covering
<app-query-link [goToResults]="true" [predefinedQueryId]="'canned_query:gocam_activity_gene_count'"></app-query-link>
genes that enable molecular functions in a
pathway. Some additional genes are included as pathway targets but are
not yet modelled as enablers, bringing the total number of genes
represented to <app-query-link [goToResults]="true" [predefinedQueryId]="'canned_query:genes_in_gocam_models'"></app-query-link>.

Based on current biological knowledge, we predict that we can
currently model approximately 3,500 Schizosaccharomyces pombe proteins
into GO-CAM pathways.  We are currently focused on modelling central
metabolism (<app-query-link [goToResults]="true" [predefinedQueryId]="'gocam_modelled_central_metabolism_genes'"></app-query-link>/<app-query-link [goToResults]="true" [predefinedQueryId]="'central_metabolism_genes'"></app-query-link>
covered), the mitochondrial proteome
(<app-query-link [goToResults]="true" [predefinedQueryId]="'gocam_modelled_mitochondrial_genes'"></app-query-link>/<app-query-link [goToResults]="true" [predefinedQueryId]="'mitochondrial_genes'"></app-query-link>
covered), heterochromatin assembly
(<app-query-link [goToResults]="true" [predefinedQueryId]="'gocam_modelled_heterochromatin_genes'"></app-query-link>/<app-query-link [goToResults]="true" [predefinedQueryId]="'heterochromatin_genes'"></app-query-link>
covered) and signalling pathways
(<app-query-link [goToResults]="true" [predefinedQueryId]="'gocam_modelled_signaling_genes'"></app-query-link>/<app-query-link [goToResults]="true" [predefinedQueryId]="'signaling_genes'"></app-query-link>
covered). However, we intend to provide pathway models for all cell-level
biological processes present in the fission yeast S. pombe.



</div>

<div class="model-graph">
  <h4>
    Genes in GO-CAM pathway models over time:
  </h4>
  <a href="/assets/go-cam-date-vs-gene-count.svg"
     title="Genes in GO-CAM pathways over time (click for larger view)">
  <img class="plot-image" alt="Genes in GO-CAM pathways over time"
       src="/assets/go-cam-date-vs-gene-count.svg" />
  </a>
</div>

<div class="model-graph">
  <h4>
    Number of GO-CAM pathway models over time:
  </h4>
  <a href="/assets/go-cam-date-vs-model-count.svg"
     title="Number of GO-CAM pathways over time">
    <img class="plot-image" alt="Number of GO-CAM pathways over time"
         src="/assets/go-cam-date-vs-model-count.svg" />
  </a>
</div>

<div>
  (From the <a routerLink="/metrics">Literature and curation metrics page</a>)
</div>

</details>
